import { Link } from "react-router-dom";
import { ArrowUpRight, MoveRight } from "lucide-react";

const HERO_BG = "https://static.prod-images.emergentagent.com/jobs/3a30fb0f-b7cc-433f-9f20-4e03192e39b7/images/634ffa40b3c91d09d442f75ba6fc164d223d02964a6868d11b3eb89903a3d3a4.png";

export default function Hero() {
  return (
    <section className="relative min-h-[100vh] overflow-hidden grain" data-testid="hero-section">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#030712]/85 via-[#030712]/75 to-[#030712]" aria-hidden />
      <div className="absolute inset-0 bg-[radial-gradient(800px_400px_at_70%_30%,rgba(56,189,248,0.18),transparent_60%)]" aria-hidden />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-40 pb-28">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 lg:col-span-9 fade-up">
            <p className="overline">In Motion · Across Industries · Practice No. 07</p>
            <h1 className="font-display font-light text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95] mt-6 max-w-5xl">
              The point of view <br className="hidden sm:block" />
              that <span className="italic text-[var(--pov-cyan)]">moves capital,</span> <br className="hidden sm:block" />
              policy and place.
            </h1>
            <p className="mt-8 max-w-2xl text-white/65 text-base sm:text-lg leading-relaxed">
              Point Ov View is a consulting practice built for speed. We work at the seam of finance,
              government, architecture, hospitality, travel, tourism and luxury goods — and move our
              clients from idea to executed deal without the deck-driven detours.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4 fade-up delay-200">
              <Link to="/book" className="btn-primary" data-testid="hero-book-btn">
                Book a Consultation <ArrowUpRight className="w-4 h-4" />
              </Link>
              <a href="#fields" className="btn-secondary" data-testid="hero-explore-btn">
                Explore Expertise <MoveRight className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="hidden lg:flex col-span-3 flex-col justify-end gap-4 fade-up delay-300">
            <div className="glass p-6 rounded-sm">
              <p className="overline mb-2">Active Fields</p>
              <p className="font-display text-4xl">08</p>
              <p className="text-xs text-white/55 mt-1">Disciplines under practice</p>
            </div>
            <div className="glass p-6 rounded-sm">
              <p className="overline mb-2">Lead Consultant</p>
              <p className="font-display text-lg leading-tight">Khrystopher Bargaineer</p>
              <p className="text-xs text-white/55 mt-1">Founder · Principal Strategist</p>
            </div>
          </div>
        </div>

        <div className="mt-24 hairline pt-6 grid grid-cols-2 md:grid-cols-4 gap-6 fade-up delay-400">
          {[
            ["20+", "Sovereign & private engagements"],
            ["8", "Disciplines under one roof"],
            ["$1.4B", "Capital influenced"],
            ["07", "Continents traversed"],
          ].map(([n, label]) => (
            <div key={label} data-testid={`hero-stat-${label.split(" ")[0].toLowerCase()}`}>
              <p className="font-display text-3xl">{n}</p>
              <p className="text-xs text-white/50 mt-1 tracking-wide">{label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
